<template>
    <h2>Customer Confirm Orders</h2>
    <router-view />
</template>

<script>
export default {
    
}
</script>